import { Button, InputNumber, Tag } from "antd";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { BiTrash } from "react-icons/bi";
import { NAME_SPACES } from "shared/locales/constants";
import PricingInput from "./PricingInput";

const BenefitRow = ({
  mapping,
  showPricing,
  onRemove,
  onFieldChange,
  onPricerChange,
  zones,
  ageBrackets,
  regimes,
}) => {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.ADMIN.INSURANCE_PLAN);
  const benefit = get(mapping, "coverage", {});
  const limits = get(mapping, "limits", []);

  const saveField = (field, val) => {
    onFieldChange(field, val);
  };

  return (
    <div className="benefit-row">
      <div className="d-flex justify--between benefit-row__header">
        <div>
          <span className="benefit-row__title">{benefit.type}</span>
          {benefit.subtype && (
            <span className="benefit-row__subtitle"> — {benefit.subtype}</span>
          )}
          {benefit.requirement && (
            <span className="benefit-row__subtitle m-left-8">
              ({benefit.requirement})
            </span>
          )}
        </div>
        <Button
          type="text"
          danger
          icon={<BiTrash size={16} />}
          onClick={onRemove}
        />
      </div>

      <div className="benefit-row__fields">
        <div className="benefit-row__field">
          <label>{t("CONFIGURE.BENEFIT_ROW.WAITING_PERIOD")}</label>
          <InputNumber
            size="small"
            min={0}
            value={get(mapping, "carenceDays")}
            onChange={(val) => saveField("carenceDays", val)}
            className="configure-field--sm"
            addonAfter={t("CONFIGURE.REVIEW.DAYS_SUFFIX")}
            placeholder="0"
          />
        </div>
        <Tag>{t("CONFIGURE.BENEFIT_ROW.LIMITS", { count: limits.length })}</Tag>
      </div>

      {showPricing && (
        <div className="benefit-row__pricing">
          <label>{t("CONFIGURE.BENEFIT_ROW.PRICING")}</label>
          <PricingInput
            value={get(mapping, "pricer.prices")}
            zones={zones}
            ageBrackets={ageBrackets}
            regimes={regimes}
            onChange={onPricerChange}
          />
        </div>
      )}
    </div>
  );
};

export default BenefitRow;
